import React, { FunctionComponent } from 'react';
import { GraduationList } from '../../../types/personShow';

type Props = {
  selectedYear: string;
  graduationList: GraduationList;
  handleChange: (event: React.MouseEvent<HTMLLIElement>) => void;
 };

export const Presentation: FunctionComponent<Props> = ({
  selectedYear,
  graduationList,
  handleChange,
}) => {
  return (
    <div className="person__show__modal__inner">
      <p className="person__show__modal__inner--title">
        卒業(予定)年を選択して保存してください
        <span className="subtitle">※現在、大学3年生の方は{graduationList.third_year}年卒です(4年制の場合)</span>
      </p>
      <ul className="person__show__modal__inner__list">
        {[
          { label: '既卒', value: '既卒' },
          { label: `${graduationList.fourth_year}年3月卒業予定(大学4年生･専門2年生など)`, value: graduationList.fourth_year },
          { label: `${graduationList.third_year}年3月卒業予定(大学3年生･専門1年生など)`, value: graduationList.third_year },
          { label: `${graduationList.second_year}年3月卒業予定(大学2年生など)`, value: graduationList.second_year },
          { label: `${graduationList.first_year}年3月卒業予定(大学1年生など)`, value: graduationList.first_year },
          { label: 'その他', value: 'その他' }
        ].map(item => (
          <li
            key={item.value}
            onClick={handleChange}
            className={selectedYear === (item.value === '既卒' || item.value === 'その他' ? item.value : `${item.value}年卒`) ? 'active' : ''}
          >
            <p data-id={item.value}>{item.label}</p>
            {selectedYear === (item.value === '既卒' || item.value === 'その他' ? item.value : `${item.value}年卒`) && (
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none">
                <path d="M4.88542 9.89714L0.21875 5.23047L1.11458 4.33464L4.88542 8.10547L12.8854 0.105469L13.7812 1.0013L4.88542 9.89714Z" fill="#19190F"/>
              </svg>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
